(() => {
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-filter]');
    if (!filter) return;
    const root = filter.closest('[data-sk-root]');
    if (!root) return;
    root.querySelectorAll('[data-filter]').forEach(button => {
      button.classList.toggle('active', button === filter);
      button.setAttribute('aria-pressed', String(button === filter));
    });
    root.querySelectorAll('[data-sk-category]').forEach(card => {
      card.hidden = filter.dataset.filter !== 'all' && card.dataset.skCategory !== filter.dataset.filter;
    });
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-sk-add] form');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-sk-status]');
    if (button.disabled) return;
    const data = new FormData(form);
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      data.append('sections_url', window.location.pathname);
      drawer.setActiveElement(button);
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
      if (document.querySelector('cart-items:not(cart-drawer-items)')) { window.location.reload(); return; }
      if (!drawer || !result.sections) { window.location.assign(root + 'cart'); return; }
      drawer.classList.remove('is-empty');
      try { drawer.renderContents(result); } catch { window.location.assign(root + 'cart'); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sk-product-form', cartData: result });
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('click', event => {
    const menuLink = event.target.closest('.sk-mobile-menu a');
    if (menuLink) menuLink.closest('details').open = false;
  });
})();
